import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { raiseDispute } from '@app/_models/raiseDispute';
import { verificationDoc } from '@app/_models/verificationDoc';
import { DisputeService } from '@app/_services/dispute.service';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { LogService } from '../../_shared/log.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-employer-verification-list-dispute',
  templateUrl: './employer-verification-list-dispute.component.html',
  styleUrls: ['./employer-verification-list-dispute.component.css']
})
export class EmployerVerificationListDisputeComponent implements OnInit {
  appId;  pid;
  request: verificationDoc[];
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  DisputeDataForm: FormGroup;
  submitted = false;
  user_email;
  user_phone_no;
  user_contact_name;

  raiseDispute = new raiseDispute();

  dtTrigger: Subject<any> = new Subject<any>();
  // public data = [
  //   {applicationId: 'AP234', studentName: 'Mahesh Patil', passingYear:'2014', stream: 'Science', document: 'Degree',  verifier: 'Ravi Kumar', verifierStatus: 'Clear'},
  //   {applicationId: 'AP222', studentName: 'Rajdeep Singh', passingYear:'2016', stream: 'Arts', document: 'Marksheet', verifier: 'Ravi Kumar', verifierStatus: 'Fake'},
  //   {applicationId: 'AP987', studentName: 'Pavan Kumar', passingYear:'2015', stream: 'Science', document: 'Degree', verifier: 'Vipul Jain', verifierStatus: 'Clear'}
  // ];

  title = 'docVerification';
  dtOptions: DataTables.Settings = {};

  get f() { return this.DisputeDataForm.controls; }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  constructor(private disputeService: DisputeService, private formBuilder: FormBuilder, private eventService: LogService, public datepipe: DatePipe,
    public fb: FormBuilder, private modalService: NgbModal, config: NgbModalConfig, private SpinnerService: NgxSpinnerService, private verifyDocService: VerifyDocumentService) { }

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showErrorModalBox', { read: TemplateRef }) showErrorModalBoxTemplate: TemplateRef<any>;
  messageStr: string;
  @ViewChild('closebuttonRemark') closebuttonRemark;


  ngOnInit(): void {
    this.DisputeDataForm = this.formBuilder.group({
      email: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      reason: ['', Validators.required]
    });

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[0, 'desc']]
    };
    var userId = localStorage.getItem('user_id');
    this.disputeService.getVerifiedDocsByUserid(userId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          console.log(this.request);
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        },
      )
  }
  downloadPDF(element) {
    this.verifyDocService.getPDF(element)
      .subscribe(
        (data: Blob) => {
          var file = new Blob([data], { type: 'application/pdf' })
          var fileURL = URL.createObjectURL(file);

          var currentDate = new Date()

          // this.date=new Date();
          let latest_date = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

          // if you want to open PDF in new tab
          // window.open(fileURL); 
          var a = document.createElement('a');
          a.href = fileURL;
          a.target = element + '_' + latest_date;
          a.download = element + '_' + latest_date + '.pdf';
          document.body.appendChild(a);
          a.click();
        },
        (error) => {
          console.log('getPDF error: ', error);
        }
      );
  }
  getApplicationId(appId,id) {
    console.log("here--->", 1, appId)

    this.appId = appId;
    this.pid = id;

  }

  getUserData() {
    this.raiseDispute.reason = '';
    var user_ID = localStorage.getItem('user_id');
    this.disputeService.getUserInfoOnLode(user_ID)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          $("#phoneNumber").val(data.respData.contact_person_phone);
          $("#email").val(data.respData.company_email);
          this.user_contact_name = data.respData.contact_person_name;
          this.user_email = data.respData.email;
          this.user_phone_no = data.respData.phone_no;
          // this.request = data.respData;
          // console.log(this.request);
        },
        error => {
          console.log(error)

        },
      )
  }

  submitDispute() {
    this.raiseDispute.application_id = this.appId;
    this.raiseDispute.id = this.pid;
    if (this.raiseDispute.contact_person_name == undefined) {
      this.raiseDispute.contact_person_name = this.user_contact_name;
    }
    if (this.raiseDispute.email == undefined) {
      this.raiseDispute.email = this.user_email;
      // this.DisputeDataForm.controls.email=this.user_email;
    }
    if (this.raiseDispute.phone_no == undefined) {
      this.raiseDispute.phone_no = this.user_phone_no;
      // this.DisputeDataForm.controls.phoneNumber=this.user_phone_no;
    }
    // this.raiseDispute.contact_person_name='contact_person_name: "Rupali J"';
    this.submitted = true;

    if (this.raiseDispute.email==null && this.raiseDispute.email==null && this.DisputeDataForm.controls.reason.invalid) {

      return;
    }
    if (this.raiseDispute.email!=null && this.raiseDispute.email!=null && this.DisputeDataForm.controls.reason.invalid) {

      return;
    }

    console.log(this.raiseDispute)

    this.disputeService.saveDispute(this.raiseDispute)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          if (data.respData == true) {
            this.modalService.open(this.showModalBoxTemplate);
            // alert("Success");
            // this.router.navigate(['/studentVerificationList']);
            //  this.eventService.emit<string>("0")
          }
          if (data.respData == false) {
            this.modalService.open(this.showErrorModalBoxTemplate);
            this.messageStr = 'Failure: Dispute has already been raised against this record.';
            //alert('Failure: Dispute has already been raised against this record.')
          }
        },
        error => {
          this.closebuttonRemark.nativeElement.click();
          this.modalService.dismissAll(this.showModalBoxTemplate);
          this.eventService.emit<string>("0")
          this.SpinnerService.hide();
          console.log(error)

        }
      )
    this.SpinnerService.show();
  }

  refresh(): void {
    this.closebuttonRemark.nativeElement.click();
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>("0")
  }

}
